// extracted by mini-css-extract-plugin
export default {"radioGroup":"user-page_radioGroup__6UlxV"};